import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

export const IconBurger = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon
    className={className}
    titleAccess={titleAccess}
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none">
    <rect width="25" height="3" fill="currentColor" />
    <rect y="10" width="25" height="3" fill="currentColor" />
    <rect y="20" width="25" height="3" fill="currentColor" />
  </Icon>
);
